var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.1594 17.7663L22.2365 19.6621L12.9469 10.3725L3.65729 19.6621L1.73437 17.7663L12.9469 6.55377L24.1594 17.7663Z"}));
}

ChevronUp.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
